import React, { useEffect, useState } from 'react'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import { useSuperAdmin } from '../../hooks/SuperAdmin/useSuperAdmin'

export default function AddSuperAdmin({ superAdmin }) {
  const [superAdminData, setSuperAdminData] = useState({
    superAdminCode: '',
    email: '',
    dob: new Date().toISOString(),
    password: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    active: true,
  })

  const { addSuperAdmin, loading, updateSuperAdmin } = useSuperAdmin()

  const handleSuperAdmin = () => {
    if (superAdmin) {
      updateSuperAdmin({ ...superAdminData, superAdminId: superAdmin._id })
    } else {
      addSuperAdmin(superAdminData)
    }
  }

  useEffect(() => {
    if (superAdmin) {
      setSuperAdminData({ ...superAdmin })
    }
  }, [superAdmin])

  const data = [
    { label: 'Super Admin Code', value: superAdminData.superAdminCode, name: 'superAdminCode' },
    { label: 'First Name', value: superAdminData.firstName, name: 'firstName' },
    { label: 'Last Name', value: superAdminData.lastName, name: 'lastName' },
    { label: 'DOB', value: superAdminData.dob, name: 'dob', type: 'DATE' },
    { label: 'Email', value: superAdminData.email, name: 'email', conditions: [{ type: 'EMAIL' }] },
    { label: 'Password', value: superAdminData.password, name: 'password', type: 'password', noDisplay: superAdmin ? true : false },
    { label: 'Phone Number', value: superAdminData.phoneNumber, name: 'phoneNumber', conditions: [{ type: 'PHONE' }], type: 'NUMBER' },
    { label: 'Status', value: superAdminData.active, type: 'ACTIVE' },
  ]

  return (
    <CustomAddPage
      heading="Super Admin"
      redirect="ALL_SUPERADMINS"
      currentData={superAdmin}
      loading={loading}
      state={superAdminData}
      setState={setSuperAdminData}
      handleClick={handleSuperAdmin}
      inputFields={data}
    />
  )
}
